
<script>
    import { createEventDispatcher } from 'svelte';
  
    let inputText = '';
    let outputText = '';
    let textColor = '#ffff00'; // Default to neon yellow
  
    const dispatch = createEventDispatcher();
  
    function applyStyle() {
      outputText = inputText;
      textColor = Math.random() < 0.5 ? '#ffff00' : '#ff00ff'; // Randomly choose between neon yellow and pink
      dispatch('use');
    }
  </script>
  
  <div class="cyberpunk-styler">
    <input type="text" bind:value={inputText} placeholder="Enter your text here">
    <button on:click={applyStyle}>Apply Cyberpunk Style</button>
    <div class="output" style="color: {textColor}">
      {outputText}
    </div>
  </div>
  
  <style>
    .cyberpunk-styler {
      background-color: #1a1a1a;
      padding: 20px;
      border: 1px solid #00ffff;
    }
  
    input {
      width: 100%;
      padding: 10px;
      margin-bottom: 10px;
      background-color: #2a2a2a;
      border: 1px solid #00ffff;
      color: #00ff00;
    }
  
    button {
      background-color: #ff00ff;
      color: #1a1a1a;
      border: none;
      padding: 10px 20px;
      cursor: pointer;
      transition: all 0.3s ease;
    }
  
    button:hover {
      background-color: #00ffff;
    }
  
    .output {
      margin-top: 20px;
      font-family: 'Blender Pro', 'Courier New', monospace;
      font-size: 24px;
      text-shadow: 0 0 10px currentColor;
    }
  </style>
  